(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-jumbotron-slider"] && !Shopify.designMode) return;
  try {
    

  function jumbotron_slider () {
    $('.jumbotron-slider').not('.slick-initialized').slick({
      arrows: false,
      dots: true
    });
  }

  $(document).ready(function(){
    jumbotron_slider();
  });

  $(document).on('shopify:section:load', function(){
    jumbotron_slider();
    console.log('custom fire');
  });
  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonials-slider"] && !Shopify.designMode) return;
  try {
    

  function testimonials_slider () {
    $('.testimonials-slider').not('.slick-initialized').slick({
      arrows: false,
      dots: true
    });
  }

  $(document).ready(function(){
    testimonials_slider();
    $(document).on('shopify:section:load', function(){
      testimonials_slider();
      console.log('custom fire');
    });
  });
 
  

  } catch(e) { console.error(e); }
})();
})();
